import { nanoid } from "nanoid";
import { type CSSProperties, useState } from "react";
import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";
import { AttentionStack } from "./AttentionStack";
import { ProfileMenu } from "./ProfileMenu";
import { SearchButton } from "./SearchButton";
import { TalkToExpertButton } from "./TalkToExpert";

export function NavigationFooter({
  showActivity = true,
}: {
  showActivity?: boolean;
}) {
  const [user] = useQuery(queries.currentUser());
  const [menuAnchorName] = useState(() => `--navigation-controls-${nanoid()}`);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 16,
        flexShrink: 0,
        margin: "12px",
      }}
    >
      {user && <TalkToExpertButton user={user} />}
      <div
        role="group"
        aria-label="Navigation controls"
        style={
          {
            display: "flex",
            justifyContent: "center",
            gap: 4,
            alignItems: "center",
            padding: "0 12px",
            anchorName: menuAnchorName,
          } as CSSProperties
        }
      >
        <div style={{ minWidth: 0 }}>
          {user && (
            <ProfileMenu
              user={user}
              align="top-left"
              target={menuAnchorName}
              footerButton
            />
          )}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <SearchButton showLabel />
        </div>
        {showActivity ? (
          <AttentionStack align="left" direction="up" />
        ) : (
          <span style={{ width: 32 }} />
        )}
      </div>
    </div>
  );
}
